// login.guard.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getEssDashboardRoute } from 'src/app/environments/environment-host';
import {
  getLoginUserDetails,
  isOnboardingCompleteFromUser,
} from 'src/app/onboarding-process/utils/onboarding.util';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const user = getLoginUserDetails();
    if (user) {
      if (isOnboardingCompleteFromUser(user)) {
        this.router.navigate(getEssDashboardRoute());
      } else {
        this.router.navigate(['/onboarding', 'welcome']);
      }
      return false;
    }
    return true;
  }
}
